import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { CommonModule } from '@angular/common';

import { EscapeDialogDirective } from '../../directives/escape-dialog/escape-dialog.directive';
import { ShActionItemComponent } from '../action-item/action-item.component';
import { ActionItem } from '../action-item/entities/action-item.entity';
import { ShIconModule } from '../icon/icon.module';
import { DialogStyle } from './entities/dialog.entity';

export * from './entities/dialog.entity';

@Component({
    standalone: true,
    selector: 'sh-dialog',
    templateUrl: './dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ShIconModule, ShActionItemComponent, EscapeDialogDirective]
})
export class ShDialogComponent {
    @ViewChild('shDialog', { read: ElementRef, static: true }) private readonly dialogEl!: ElementRef;

    @Input() title?: string;
    @Input() actions?: ActionItem[];
    @Input() style: DialogStyle = DialogStyle.Normal;
    @Input() set open(doOpen: boolean) {
        if (!this.open && doOpen) {
            this.openModal();
        } else if (this.open && !doOpen) {
            this.closeModal();
        }
    }

    @Output() closed: EventEmitter<void> = new EventEmitter();
    @Output() opened: EventEmitter<void> = new EventEmitter();
    @Output() dialogStateChange: EventEmitter<boolean> = new EventEmitter();

    openModal(): void {
        if (this.nativeElement.showModal) {
            try {
                this.nativeElement.showModal();
            } catch (e) {
                this.closeModal();
            }
        } else {
            this.nativeElement.setAttribute('open', 'true');
        }
        this.dialogStateChange.next(true);
        this.opened.next();
    }

    closeModal(): void {
        if (this.nativeElement.close) {
            this.nativeElement.close();
        } else {
            this.nativeElement.removeAttribute('open');
        }
        this.dialogStateChange.next(false);
        this.closed.next();
    }

    get nativeElement(): HTMLDialogElement {
        return this.dialogEl.nativeElement as HTMLDialogElement;
    }

    get open(): boolean {
        return this.nativeElement.getAttribute('open') !== null;
    }
}
